<template>
  <div>
    <Ribbon
      v-if="bannerText != undefined"
      :text="bannerText"
      position="top left"
      :fixed="true"
    />
    <router-view />
  </div>
</template>
<script type="text/javascript">
import "@thegetty-private/getty-ui/dist/themes/getty-ui.css";
import { Ribbon, useLocalization } from "@thegetty-private/getty-ui";
import * as configHelper from "@/helpers/configHelper";
import { useHead } from "@unhead/vue";

export default {
  name: "App",
  components: {
    Ribbon
  },
  props: {
    /**
     * The base locale key for the record metadata field component
     */
    baseLocaleKey: {
      type: String,
      default: ""
    }
  },
  setup() {
    const localization = useLocalization({
      baseLocaleKey: "home",
      strings: {
        /**
         * Title template for all pages
         */
        titleTemplate: "title_template",
        /**
         * Meta tag title
         */
        title: "title",
        /**
         * Meta tag description
         */
        description: "metatag_description"
      }
    });
    return { ...localization };
  },
  computed: {
    /**
     * The status Banner text
     */
    bannerText() {
      return configHelper.getLocationBanner();
    }
  },
  mounted() {
    // our metadata is managed by unhead https://unhead.unjs.io/
    useHead({
      // all titles will be injected into this template
      titleTemplate: this.localized.titleTemplate,
      meta: [
        // these fields will render as <meta name="" content="">
        {
          name: "title",
          content: this.localized.title
        },
        // default meta description - should be 158 or fewer characters, currently over
        {
          name: "description",
          content: this.localized.description
        }
      ]
    });
  }
};
</script>

<style scoped></style>
